/**
 * Module Configuration
 * Defines modules and their associated permissions
 */

export const MODULES = {
  SECURITY: 'security',
  INVENTORY: 'inventory',
  RESULTS: 'results',
  INCOME: 'income',
  TIMESHEETS: 'timesheets',
};

export const MODULE_PERMISSIONS = {
  [MODULES.SECURITY]: {
    name: 'Veiligheidsbeheer',
    permissions: [
      'users.view',
      'users.manage',
      'roles.view',
      'roles.manage',
      'permissions.view',
    ],
  },
  [MODULES.INVENTORY]: {
    name: 'Voorraden',
    permissions: [
      // Products
      'products.view',
      'products.create',
      'products.edit',
      'products.delete',
      // Brands
      'brands.view',
      'brands.create',
      'brands.edit',
      'brands.delete',
      // Locations
      'locations.view',
      'locations.create',
      'locations.edit',
      'locations.delete',
      // Suppliers
      'suppliers.view',
      'suppliers.create',
      'suppliers.edit',
      'suppliers.delete',
      // Stock Counts
      'stock_counts.view',
      'stock_counts.create',
      'stock_counts.edit',
      'stock_counts.delete',
      // Sales
      'sales.view',
      'sales.create',
      'sales.edit',
      'sales.delete',
      // Purchases (invoices)
      'purchases.view',
      'purchases.create',
      'purchases.edit',
      'purchases.delete',
      // Statistics
      'statistics.view',
      'statistics.export',
      'statistics.manage_snapshots',
    ],
  },
  [MODULES.RESULTS]: {
    name: 'Resultaten',
    permissions: [
      'results.view',
      'results.import',
      'results.manage',
    ],
  },
  [MODULES.INCOME]: {
    name: 'Inkomsten',
    permissions: [
      'boekje_saskia.view',
      'boekje_saskia.manage',
    ],
  },
  [MODULES.TIMESHEETS]: {
    name: 'Prestaties personeel',
    permissions: [
      'timesheets.view_own',
      'timesheets.edit_own',
      'timesheets.edit_all',
      'timesheets.view_all',
      'timesheets.approve',
      'timesheets.release',
      'timesheets.download_pdf',
      'timesheets.settings',
      'contracts.manage',
    ],
  },
};

/**
 * Check if user has access to a module
 * @param {string[]} userPermissions - User's permission codes
 * @param {string} module - Module key from MODULES
 * @returns {boolean}
 */
export function hasModuleAccess(userPermissions, module) {
  const moduleConfig = MODULE_PERMISSIONS[module];
  if (!moduleConfig || !userPermissions) return false;
  return moduleConfig.permissions.some(perm => userPermissions.includes(perm));
}

/**
 * Get all modules user has access to
 * @param {string[]} userPermissions - User's permission codes
 * @returns {string[]} - Array of module keys
 */
export function getAccessibleModules(userPermissions) {
  return Object.keys(MODULE_PERMISSIONS).filter(module =>
    hasModuleAccess(userPermissions, module)
  );
}
